import { DocumentNode } from '@apollo/client';
import { getErrorMessage } from '@ts-core/lib/apollo';
import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';

import { useQuery } from '@ts-core/lib/apollo';

import { getCourseStatsQuery, GetCourseStatsQueryResult, GetCourseStatsQueryVariables } from '../graphql/queries/getCourseStatsQuery';

interface CourseStatsHookInput {
  courseId: string;

  fragment: DocumentNode;
}

interface CourseStatsHookOutput<TCourseStats> {
  stats?: TCourseStats;

  loading: boolean;
  error?: string;
  onRefetchStats: () => void;
}

export default function useCourseStats<TCourseStats>(input: CourseStatsHookInput): CourseStatsHookOutput<TCourseStats> {
  const { courseId, fragment } = input;
  const { showErrorNotification } = useSnackbarNotifications();

  const { loading, data, error, refetch } = useQuery<GetCourseStatsQueryResult<TCourseStats>, GetCourseStatsQueryVariables>(
    getCourseStatsQuery(fragment),
    {
      variables: { courseId },
      onError: showErrorNotification,
    }
  );

  return {
    stats: data?.courseStats,
    loading,
    error: getErrorMessage({ error }),

    onRefetchStats: refetch,
  };
}
